export const LOCALES = {
  SCREENSHOT_TOOLTIP: {
    ru: 'Сохранить план',
    uk: 'Зберегти план',
  },
  MOVEMODES_WALK: {
    ru: 'Прогулка',
    uk: 'Прогулянка',
  },
  MOVEMODES_ORBIT: {
    ru: 'Вид сверху',
    uk: 'Вид згори',
  },
};
